import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";

export const getPatient = async () => {
    const res = await api.get(`/Patient`);

    return {
        ...res.data,
    };
};

export const usePatient = () => {
    return useQuery({
        queryKey: ["patient"],
        queryFn: getPatient,
        retry: 3,
        staleTime: Infinity,
    });
};
